module.exports = __webpack_public_path__ + "static/media/18c-05_ST-2018-300x400cm-oleo-sobre-madera.3a30b811.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/18c/18c-05_ST-2018-300x400cm-oleo-sobre-madera.jpg
// module id = 232
// module chunks = 0